import axios, { AxiosInstance } from 'axios';
import { showNotification } from '../vue/notifications/notification_actions';

export const instance: AxiosInstance = axios.create({
  headers: {
    'Content-Type': 'multipart/form-data',
    'X-Csrf-Token': (window as any).g_opt.csrf,
  },
});
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const type: string | undefined = error?.response?.data?.type;
    const rejectTypes = ['draft_upload', 'payment_discount'];

    if (type && rejectTypes.includes(type)) {
      return Promise.reject(error);
    }

    const message = error?.response?.data?.message;
    const link = error?.response?.data?.data?.link;
    const link_title = error?.response?.data?.data?.link_title;

    showNotification('error_type', {
      emoji: '🙁',
      title: message ? message : 'Something went wrong!',
      ok_action() {},
      ...(link && { link }),
      ...(link_title && { link_title }),
    });

    return Promise.reject(error);
  }
);
